(function() {
  'use strict';

  angular
    .module('admin.publishers.service', [])
    .factory('PublisherAdminService', PublisherAdminService);

  /** @ngInject */
  function PublisherAdminService($http, $q, API) {

    function list(start, limit){
        var defer = $q.defer();

        $http.get(API.API_URL + 'admin/publishers?start=' + start + '&limit=' + limit)
            .success(defer.resolve);

        return defer.promise;
    }

    function listAll(){
        var defer = $q.defer();

        $http.get(API.API_URL + 'admin/publishers')
            .success(defer.resolve);

        return defer.promise;
    }


     function get(id){
        var defer = $q.defer();

        $http.get(API.API_URL + 'admin/publishers/' + id)
            .success(defer.resolve);

        return defer.promise;
    }

    function getPublisher(){
        var defer = $q.defer();

        $http.get(API.API_URL + 'publishers')
            .success(defer.resolve);

        return defer.promise;
    }

    function getProducers(){
        var defer = $q.defer();

        $http.get(API.API_URL + 'admin/producers')
            .success(defer.resolve);

        return defer.promise;
    }

    function getProducers2(){
        var defer = $q.defer();

        $http.get(API.API_URL + 'publisher/producers')
            .success(defer.resolve);

        return defer.promise;
    }

    function save(model){
        var defer = $q.defer();

        $http.post(API.API_URL + 'admin/publishers', model)
            .success(defer.resolve);

        return defer.promise;
    }

    function update(id, model){
        var defer = $q.defer();

        $http.post(API.API_URL + 'admin/publishers/' + id, model)
            .success(defer.resolve);

        return defer.promise;
    }

     function updatePublisher(id, model){
        var defer = $q.defer();

        $http.post(API.API_URL + 'publisher/publishers/' + id, model)
            .success(defer.resolve);

        return defer.promise;
    }

    function remove(id){
        var defer = $q.defer();

        $http.delete(API.API_URL + 'admin/publishers/' + id)
            .success(defer.resolve);

        return defer.promise;
    }

    function addUserProducer(parentId, id){
        var defer = $q.defer();

        $http.post(API.API_URL + 'admin/publishers/' + parentId + '/users/' + id)
            .success(defer.resolve);

        return defer.promise;
    }

    return{
        list: list,
        listAll: listAll,
        remove: remove,
        get: get,
        save: save,
        addUserProducer: addUserProducer,
        update: update,
        updatePublisher: updatePublisher,
        getPublisher: getPublisher,
        getProducers: getProducers,
        getProducers2: getProducers2
    };

  }

})();
